import Decimal from "decimal.js";
import { IArea } from "../../../../interfaces/common/location";

export enum DeliveryChargeRuleScope {
  AREA = "AREA",
  DISTRICT = "DISTRICT",
  GOVERNORATE = "GOVERNORATE",
}

export interface IDeliveryChargeRule {
  id?: number;
  scope: DeliveryChargeRuleScope;
  delta_charge: Decimal;
  area?: IArea;
  district?: string;
  governorate?: string;
  is_deleted?: boolean;
}
